import { useEffect, useState } from "react";
import RenterWalkthroughStage from "./RenterWalkthroughStage";

/**
 * Mounted at /embed/renter-walkthrough: a minimal, unlisted route whose
 * only job is to render RenterWalkthroughStage inside its own real
 * (same-origin) document, driven entirely by postMessage from the parent
 * window (PhoneFrame.jsx). This is what makes Phone mode genuinely
 * responsive: this document has its own real viewport at whatever width
 * the iframe is set to, so the real components' Tailwind breakpoints
 * respond correctly: no forced desktop layout squeezed into a narrow box.
 */
export default function WalkthroughStageFrame() {
  const [state, setState] = useState(null);

  useEffect(() => {
    function onMessage(e) {
      if (e.origin !== window.location.origin) return;
      const data = e.data;
      if (!data || typeof data !== "object") return;
      if (data.type === "WALKTHROUGH_STATE") {
        setState({ stepIndex: data.stepIndex, demoState: data.demoState, reducedMotion: data.reducedMotion, resetToken: data.resetToken, deviceMode: data.deviceMode });
      }
      if (data.type === "WALKTHROUGH_PING" && window.parent) {
        window.parent.postMessage({ type: "WALKTHROUGH_FRAME_READY" }, window.location.origin);
      }
    }
    window.addEventListener("message", onMessage);
    if (window.parent) {
      window.parent.postMessage({ type: "WALKTHROUGH_FRAME_READY" }, window.location.origin);
    }
    return () => window.removeEventListener("message", onMessage);
  }, []);

  function onEvent(event) {
    window.parent?.postMessage({ type: "WALKTHROUGH_EVENT", event }, window.location.origin);
  }

  if (!state || !state.demoState) {
    return <div className="min-h-screen grid place-items-center text-sm text-slate-400">Loading preview…</div>;
  }

  return (
    <RenterWalkthroughStage
      stepIndex={state.stepIndex}
      demoState={state.demoState}
      deviceMode={state.deviceMode || "phone"}
      onEvent={onEvent}
      reducedMotion={state.reducedMotion}
      resetToken={state.resetToken}
    />
  );
}
